import { z } from 'zod/v4'
import { VisitKolDetailProperties } from '@/utils/ampli'

type CreateEnumRecord<T extends string> = Record<T, T>

/**
 * @todo Move to routes
 * From values map for Zod validation
 * 使用 Record 類型確保與 VisitKolDetailProperties['from'] 自動同步
 * 新增/移除值時 TypeScript 會自動檢查一致性
 */
const validFromValuesMap: CreateEnumRecord<
  NonNullable<VisitKolDetailProperties['from']>
> = {
  similarInfluencer: 'similarInfluencer',
  relatedInfluencer: 'relatedInfluencer',
  socialAccountRanking: 'socialAccountRanking',
  'Landing Page': 'Landing Page',
  'Deep Report': 'Deep Report',
  Checkout: 'Checkout',
  Chatroom: 'Chatroom',
  Campaign: 'Campaign',
  Collection: 'Collection',
  Competitor: 'Competitor',
  hashtag: 'hashtag',
  'Quick Search': 'Quick Search',
  'General Search': 'General Search',
  'chrome-extension': 'chrome-extension',
  'Public KOL Search': 'Public KOL Search',
  'Other Country': 'Other Country',
  'AI Module in General': 'AI Module in General',
  Directory: 'Directory',
  'Similar KOL in Collection': 'Similar KOL in Collection',
  'KOL Detail': 'KOL Detail',
  Proposal: 'Proposal',
  'Content Search': 'Content Search',
  'AI Search': 'AI Search',
}

export const visitKolDetailPropertiesFromSchema = z.enum(
  Object.values(validFromValuesMap),
)
